"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatars = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _Videocam = _interopRequireDefault(require("@material-ui/icons/Videocam"));
var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _excluded = ["name", "imgSrc", "mode", "size", "simMode"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    //@ts-ignore
    root: _objectSpread({
      width: "36px",
      height: "36px",
      color: _pittaModules.LightColors.primary["0"],
      backgroundColor: function backgroundColor(props) {
        return props.mode === "admin" ? _pittaModules.LightColors.primary["0"] : _pittaModules.LightColors.primary["7"];
      }
    }, _Fonts.Fonts.Default.Body),
    rootImage: {
      backgroundColor: "#FFFFFF"
    },
    Lroot: {
      width: theme.spacing(10),
      height: theme.spacing(10)
    },
    rootSubscribed: {
      width: theme.spacing(13),
      height: theme.spacing(13),
      backgroundColor: "".concat(_pittaModules.LightColors.secondary["15"], "!important")
    },
    rootCancelled: {
      width: theme.spacing(13),
      height: theme.spacing(13),
      backgroundColor: "".concat(_pittaModules.LightColors.secondary["11"], "!important")
    },
    rootTerminated: {
      width: theme.spacing(13),
      height: theme.spacing(13),
      backgroundColor: "".concat(_pittaModules.LightColors.primary["4"], "!important")
    },
    fallback: {
      display: function display(props) {
        return props.mode === "none" ? "none" : "";
      },
      backgroundColor: function backgroundColor(props) {
        return props.mode === "admin" ? _pittaModules.LightColors.primary["0"] : _pittaModules.LightColors.primary["7"];
      }
    }
  });
});
var Avatars = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _clsx;
  var classes = useStyles(props);
  var name = props.name,
    imgSrc = props.imgSrc,
    mode = props.mode,
    size = props.size,
    simMode = props.simMode,
    restProps = _objectWithoutProperties(props, _excluded);
  var getIcon = function getIcon() {
    if (mode === "camera") {
      return /*#__PURE__*/_react.default.createElement(_Videocam.default, {
        style: {
          fontSize: size === "large" ? "3.375rem" : "1.5rem"
        }
      });
    } else if (mode === "admin") {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: "relative",
          width: 80
        }
      }, /*#__PURE__*/_react.default.createElement(_AccountCircle.default, {
        style: {
          fontSize: size === "large" ? "5rem" : "1.5rem",
          color: _pittaModules.LightColors.primary["6"]
        }
      }), /*#__PURE__*/_react.default.createElement("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          position: "absolute",
          top: 0,
          right: 0
        }
      }, /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM40 73C58.2254 73 73 58.2254 73 40C73 21.7746 58.2254 7 40 7C21.7746 7 7 21.7746 7 40C7 58.2254 21.7746 73 40 73Z",
        fill: "#E9E9EA"
      })));
    } else if (mode === "sim") {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: 44,
          height: 55
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: "44",
        height: "55",
        viewBox: "0 0 44 55",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {}
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M35.7661 35.7629V24.7887H30.2339V35.7629H35.7661ZM24.7018 30.2113V24.7887H19.2982V30.2113H24.7018ZM24.7018 46.7371V35.7629H19.2982V46.7371H24.7018ZM13.7661 35.7629V24.7887H8.23392V35.7629H13.7661ZM35.7661 46.7371V41.3146H30.2339V46.7371H35.7661ZM13.7661 46.7371V41.3146H8.23392V46.7371H13.7661ZM43.8713 5.42254L44 49.5775C44 51.0407 43.4425 52.3318 42.3275 53.4507C41.2125 54.4836 39.9259 55 38.4678 55H5.53216C4.07407 55 2.78752 54.4836 1.67251 53.4507C0.557505 52.3318 0 51.0407 0 49.5775V16.5258L16.4678 0H38.4678C39.9259 0 41.1696 0.559468 42.1988 1.6784C43.3138 2.71127 43.8713 3.95931 43.8713 5.42254Z",
        fill: "white"
      })));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Avatar.default, _extends({
    ref: ref,
    classes: {
      root: (0, _clsx2.default)(classes.root, size === "large" && classes.Lroot, (_clsx = {}, _defineProperty(_clsx, classes.rootSubscribed, simMode === "Subscribed"), _defineProperty(_clsx, classes.rootCancelled, simMode === "Cancelled"), _defineProperty(_clsx, classes.rootTerminated, simMode === "Terminated"), _clsx)),
      img: classes.rootImage,
      fallback: classes.fallback
    },
    alt: name,
    src: imgSrc || "empty"
  }, restProps), getIcon());
});
exports.Avatars = Avatars;